import React, { type FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { AddRounded } from '@mui/icons-material'

import { Translation } from '../../../domain'

import { useAsyncCallback } from '../Callback'
import { Button } from '../common'
import { FormattedTranslation } from '../Internationalization'
import { useAppUsecases } from '../State'

const buttonStyle: SxProps<Theme> = { ml: 2 }

const NewButton: FC<Readonly<{ label: Translation, onClick: VoidFunction }>> = ({ label, onClick }) => (
    <Button data-testid="add-button" sx={buttonStyle} variant="primary" size="large" startIcon={<AddRounded />} onClick={onClick}>
        <FormattedTranslation id={label} />
    </Button>
)

export const NewUserButton: FC = () => {
    const { createUserUsecase } = useAppUsecases()
    const [onClick] = useAsyncCallback(() => createUserUsecase.start(), [createUserUsecase])

    return <NewButton label={Translation.NEW_USER} onClick={onClick} />
}

export const NewRoleButton: FC = () => {
    const { createRoleUsecase } = useAppUsecases()
    const [onClick] = useAsyncCallback(() => createRoleUsecase.start(), [createRoleUsecase])

    return <NewButton label={Translation.NEW_ROLE} onClick={onClick} />
}
